// extracted by mini-css-extract-plugin
export default {"headerText":"Headlines_headerText__Y1o7J","subheaderText":"Headlines_subheaderText__y475Z","visitorCount":"Headlines_visitorCount__souqv"};